import ReferalCard from './ReferalCard'

export default ReferalCard